"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanesThumbnails = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const hooks_1 = require("../../hooks");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const analytics_1 = require("@completeanatomy/analytics");
const react_router_dom_1 = require("react-router-dom");
function PlanesThumbnails({ className, items, children, }) {
    const bridge = (0, bridge_1.useBridge)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const availableTabs = (0, hooks_1.useAvailableTabs)();
    const location = (0, react_router_dom_1.useLocation)();
    const analytics = (0, analytics_1.useAnalytics)();
    const sendAnalyticsEvent = (title) => {
        let segmentation = {
            name: title,
            toolType: bridge_schema_1.InfoBoxTabType.Description,
            accessLocation: analytics_1.AnalyticsAccessLocation.Infobox,
        };
        analytics.log('InfoboxItemSelected', segmentation);
    };
    const thumbnailClickHandler = (index) => () => {
        const isCluster = availableTabs.includes(bridge_schema_1.InfoBoxTabType.Explode);
        const path = `/mode/isolate${isCluster ? '?cluster=true' : ''}`;
        sendAnalyticsEvent(children[index].title);
        bridge === null || bridge === void 0 ? void 0 : bridge.selectPartPlane(index);
        navigate(path, { replace: path === location.pathname });
    };
    return ((0, jsx_runtime_1.jsx)(StyledScrollView, { className: className, horizontal: true, "data-e2e": 'PlanesThumbnails_StyledScrollView', children: (items !== null && items !== void 0 ? items : children).map(({ index, img, title, isSelected }) => ((0, jsx_runtime_1.jsxs)(ThumbnailContainer, { role: "button", onClick: thumbnailClickHandler(index), "$isSelected": isSelected, "aria-pressed": isSelected, "data-e2e": 'PlanesThumbnails_ThumbnailContainer', children: [(0, jsx_runtime_1.jsx)(ThumbnailImage, { src: `/${img}`, "data-e2e": 'PlanesThumbnails_ThumbnailImage' }), (0, jsx_runtime_1.jsx)(ThumbnailLabel, { "data-e2e": 'PlanesThumbnails_ThumbnailLabel', children: title })] }, title))) }));
}
exports.PlanesThumbnails = PlanesThumbnails;
const StyledScrollView = (0, styled_components_1.default)(ui_1.ScrollView) `
  flex-shrink: 0;
`;
const ThumbnailContainer = styled_components_1.default.div `
  margin-left: 11px;

  color: ${({ $isSelected, theme }) => $isSelected ? theme.text : theme.textSecondary};
  font-weight: ${({ $isSelected }) => ($isSelected ? 600 : 400)};

  background-color: ${({ $isSelected, theme }) => $isSelected ? theme.infoBox.selectedThumbnail : 'none'};

  cursor: pointer;

  &:first-child {
    margin-left: 0;
  }
`;
const ThumbnailImage = styled_components_1.default.img `
  width: 77px;
  height: 110px;
`;
const ThumbnailLabel = styled_components_1.default.div `
  min-height: 22px;
  margin-bottom: 11px;

  font-size: 11px;
  text-align: center;
`;
